import { render, staticRenderFns } from "./SimulationBasicForm.vue?vue&type=template&id=e267b544&"
import script from "./SimulationBasicForm.vue?vue&type=script&lang=js&"
export * from "./SimulationBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports